export default __webpack_public_path__ + "static/media/bg_pengetahuan_mobile.1642feae.webp";